export default __webpack_public_path__ + "static/media/BA11.3f276b25.jpg";